"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validateNpi_1 = require("./validateNpi");
const validateDob_1 = require("./validateDob");
const validateZip_1 = require("./validateZip");
const validateTime_1 = require("./validateTime");
const validateDate_1 = require("./validateDate");
const validateEmail_1 = require("./validateEmail");
const validatePhone_1 = require("./validatePhone");
const validateSsn_1 = require("./validateSsn");
const validateStringNumber_1 = require("./validateStringNumber");
const validators = {
    dob: validateDob_1.validateDob,
    phone: validatePhone_1.validatePhone,
    ssn: validateSsn_1.validateSsn,
    partialSsn: validateSsn_1.validatePartialSsn,
    email: validateEmail_1.validateEmail,
    time: validateTime_1.validateTime,
    date: validateDate_1.validateDate,
    zip: validateZip_1.validateZip,
    npi: validateNpi_1.validateNpi,
    stringNumber: validateStringNumber_1.validateStringNumber
};
exports.default = validators;
//# sourceMappingURL=index.js.map